export const UserPermissionsLocalKey = 'user_permissions';

export function getUserPermissionsFromLocal() {
  const storage = window.localStorage.getItem(UserPermissionsLocalKey);
  if (!storage) return null;
  return JSON.parse(storage);
}

export function setUserPermissionsToLocal(userPermissions) {
  window.localStorage.setItem(
    UserPermissionsLocalKey,
    JSON.stringify(userPermissions),
  );
}

export function removeUserPermissionsFromLocal() {
  window.localStorage.removeItem(UserPermissionsLocalKey);
}
